import React, { useContext, useEffect } from 'react';
import { IDisbursementRollupProps } from '../IDisbursementRollupProps';
import { DisbursementRollupDispatchContext } from './DisbursementRollupContext';

export const DisbursementRollup: React.FC<IDisbursementRollupProps> = ({ id, dirty, onSubmit }) => {
  const dispatch = useContext(DisbursementRollupDispatchContext);
  useEffect(() => {
    dispatch(id, { id, dirty, onSubmit });
    return () => dispatch(id, undefined);
  }, [id, dirty, onSubmit, dispatch]);
  return <></>;
};
